import { useToast } from "../../../components/ui/use-toast";
import { addWidgetToSectionAPI } from "../../../api/dashboardApi";
import { Button } from "../../../components/ui/button";
import { DropdownMenuItem } from "../../../components/ui/dropdown-menu";
import { useState } from "react";
import SolidSpinnerIcon from "../../../assets/icons/SolidSpinnerIcon";

const PinDashboardSectionItem = ({ label, msgId, dashboardId, sectionId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();
  const handleAddToSection = () => {
    toast({
      title: (
        <div className="flex gap-2 items-center">
          <div>
            <SolidSpinnerIcon className="w-4 h-4 animate-spin" />
          </div>
          Adding
        </div>
      ),
      description: "Adding widget to section",
    });
    addWidgetToSectionAPI({ dashboardId, msgId, sectionId, setIsLoading });
  };

  return (
    <DropdownMenuItem
      //   onSelect={(event) => event.preventDefault()}
      key={label}
      className="group/item justify-between focus:bg-zinc-800 hover:bg-zinc-800 focus:text-zinc-100"
    >
      <span className="truncate">{label}</span>
      <Button
        onClick={handleAddToSection}
        className="invisible group-hover/item:visible h-auto hover:bg-zinc-700 hover:text-zinc-100 px-3 py-1 dark:hover:bg-zinc-700 shadow-none"
        size="sm"
        variant="ghost"
      >
        Add
      </Button>
    </DropdownMenuItem>
  );
};

export default PinDashboardSectionItem;
